import React, {useState, useEffect} from 'react';
import {Header, Titulo} from '../elementos/Header'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import withRouter from './withRouter';
import Api from '../servicios/api'
import BtnRegresar from '../elementos/BtnRegresar'
import FormularioAutor from './FormularioAutor'
import favicon from '../imagenes/logoutm.png'
import Cargando from '../elementos/Cargando'

const EditarAutor = (props) => {
    const [datosCargados, setdatosCargados] = useState(false);
    const [autor, setAutor] = useState([]);

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        fetch(Api+"?consultarAutorID="+props.params.id)
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            setdatosCargados(true);
            setAutor(datosRespuesta[0]);
        })
        .catch(console.log)
    }, [props]);

    if(!datosCargados){
        return(
            <Cargando />
        );
    }
    else{
        return (
            <>
                <HelmetProvider>
                    <div>
                        <Helmet>
                            <link rel="shortcut icon" href={favicon} type="image/x-con"/>
                            <title>Actualizar Autor</title>
                        </Helmet>
                    </div>
                </HelmetProvider>

                <Header>
                        <Titulo>Actualizar Autor</Titulo>
                        <BtnRegresar ruta="/autores"/>
                </Header>

                <FormularioAutor autor={autor}/>
            </>
        );
    }
}
 
export default withRouter(EditarAutor);